import { bl_fi_mst_item_ext_RowClass, bl_fi_mst_item_hdr_RowClass, bl_fi_mst_item_image_hdr_RowClass, bl_fi_mst_item_line_RowClass, bl_fi_mst_item_line_RowInterface, bl_inv_current_company_stock_balance_RowClass, bl_inv_current_location_stock_balance_RowClass } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';

export class FinancialItemContainerModel extends BaseContainerModel {
  bl_fi_mst_item_hdr: bl_fi_mst_item_hdr_RowClass = new bl_fi_mst_item_hdr_RowClass();
  bl_fi_mst_item_lines: bl_fi_mst_item_line_RowClass[] = [];
  bl_fi_mst_item_exts: bl_fi_mst_item_ext_RowClass[] = [];
  bl_fi_mst_item_image_hdrs?: bl_fi_mst_item_image_hdr_RowClass[] = [];
}

export class FinancialItemLineModel extends BaseContainerModel {
  bl_fi_mst_item_line: bl_fi_mst_item_line_RowInterface = new bl_fi_mst_item_line_RowClass();
}

export class FinancialItemQueryCriteria {
  offset: number;
  limit: number;
  orderBy: string;
  order: string;
  keyword: string;
  txn_type: string;
  code: string;
  name: string;
  descr: string;
  status: string;
  param_code: string;
  value_string: string;
  // exts: ExtQueryCriteria[] = new Array();
}
